export default __webpack_public_path__ + "static/media/twitter-Contactus.573d2f70.svg";